import { Dropdown, Input, Table } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import svg27 from "../../../assets/svg/svg27.svg"; 
import InsideHeader from "../../../components/InsideHeader"; 
import svg38 from "../../../assets/svg/svg38.svg";
import MaterialIcon from "material-icons-react";   
import { setAttendanceObj, setStaffObj } from "../../../features/folder/folderSlice";
import FilterModal from "./FilterModal";
import { fetchAttendance } from "../../../features/dropdown/dropdownSlice";
import { dateForHumans, timePart } from "../../../utils";
 

export default function AttendanceTable() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { attendance, loading, attendanceCount } = useSelector(
    (state) => state.dropdown
  );
 
  const [open, setopen] = useState(false);

  function handleCancel() {
    setopen(false);
  }
  const [filters, setFilters] = useState([]);
  const [formData, setFormData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModalFilter = () => {
    setIsModalOpen(true);
  };

  const handleClearFilters = async () => {
    await setFormData({});
    await dispatch(fetchAttendance());
    await setFilters([]);
  };

  const [prodd, setProdd] = useState("");
  const [isModalOpenDelete, setIsModalOpenDelete] = useState(false);
  const showModalDelete = async () => {
    setIsModalOpenDelete(true);
  };

  const handleDelete = async () => {
    
  };

  const handleNdovu = async () => {
    navigate('/ndovu-pay')
  };

  const handleExport = () => {
     
  };

  const handleView=async()=>{
    await dispatch(setAttendanceObj(prodd))
    await navigate("/casual-attendace-details")
  }
  const settingItems = [
    {
      key: "0",
      label: (
        <Link
          onClick={handleView}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
         Details
        </Link>
      ),
    },
    {
      key: "1",
      label: (
        <Link
          onClick={handleExport}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
          Export To Excel
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <div
          onClick={handleNdovu}
          className="flex  text-[16px] font-sans   !text-lightBlack"
        >
          Initiate Ndovupay Payment
        </div>
      ),
    },
  ];

  const columns = [
    {
      title: "Date",
      dataIndex: "attCreatedDate",
      render:(item)=>{
        return(
          <div>{dateForHumans(item)}</div>
        )
      },
      sorter: (a, b) => a.attCreatedDate - b.attCreatedDate,
    },
    {
      title: "Personnel No",
      dataIndex: "ppPfno",
      sorter: (a, b) => a.ppPfno - b.ppPfno,
    },
    {
      title: "Name",
      dataIndex: "ppFullname",
      sorter: (a, b) => a.ppFullname - b.ppFullname,
    },
    {
      title: "Clocked In",
      dataIndex: "checkInTime",
      render:(item)=>{
        return(
          <div>{item}</div>
        )
      },
      sorter: (a, b) => a.checkInTime - b.checkInTime,
    },
    {
      title: "Clocked Out",
      dataIndex: "checkOutTime",
      sorter: (a, b) => a.checkOutTime - b.checkOutTime,
    },
    {
      title: "Hours Worked",
      dataIndex: "attHoursWorked",
      sorter: (a, b) => a.attHoursWorked - b.attHoursWorked,
    },
    {
      title: "Overtime Hours Worked",
      dataIndex: "attOvertimeHours",
      sorter: (a, b) => a.attOvertimeHours - b.attOvertimeHours,
    },
    // {
    //   title: "Actions",
    //   render: (item) => (
    //     <>
    //       <Dropdown
    //         overlayStyle={{
    //           width: "250px",
    //         }}
    //         trigger={"click"}
    //         menu={{ items: settingItems }}
    //         placement="bottom"
    //       >
    //         <button onClick={() => setProdd(item)}>
    //           <img src={svg27} alt="svg27" />
    //         </button>
    //       </Dropdown>
    //     </>
    //   ),
    // },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchAttendanceData(page, size) {
    dispatch(
      fetchAttendance({
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    fetchAttendanceData();
  }, []);

  return (
    <div className="w-full h-full overflow-y-scroll">
      <InsideHeader
        title="Casual Attendance Entries Information"
        subtitle="Manage Attendance Entries within your institution"
        back={false}
      />
 
        <div className="bg-white rounded-[10px] mt-[1.25rem] h-full">
          <div className="flex flex-col w-full lg:px-10 px-3 ">
            <h3 className="font-[700] text-[24px] text-lightBlack dash-title mt-[1.25rem]">
             Casual Attendance Entries Details
            </h3>
            <div className="mt-5 flex lg:flex-row flex-col gap-y-5 justify-between lg:items-center items-start w-full">
              <div className="flex items-center">
                <span>
                  {" "}
                  <button
                    onClick={showModalFilter}
                    type="button"
                    className={`bg-transparent flex items-center gap-x-'1' ${
                      Object?.keys(formData)?.length > 0
                        ? "!text-[#5688E5]"
                        : "inherit"
                    }`}
                  >
                    <MaterialIcon color="#141414" icon="filter_list" />
                    Filters
                  </button>
                </span>
                {Object?.keys(formData)?.length > 0 && (
                  <span className="flex items-center text-[#5688E5] cursor-pointer ml-1">
                    :{Object?.keys(formData)?.length}
                    <img src={svg38} alt="svg38" onClick={handleClearFilters} />
                  </span>
                )}
              </div>
           
            </div>
            <div className="dash-inner-page mt-[24px] max-w-full w-full overflow-x-auto">
              <section>
                <Table
                  rowSelection={false}
                  className="mt-[1.31rem] w-full"
                  scroll={{
                    x: 800,
                  }}
                  rowKey={(record) => record?.attId}
                  columns={columns}
                  dataSource={attendance}
                  loading={loading}
                  pagination={{
                    position: ["bottomCenter"],
                    current: pageIndex + 1,
                    total: attendanceCount,
                    pageSize: pageSize,
                    onChange: (page, size) => {
                      setPageIndex(page - 1);
                      setPageSize(size);
                      fetchAttendanceData(page - 1, size);
                    },
                    showSizeChanger: false,
                    hideOnSinglePage: true,
                  }}
                />
              </section>
            </div>
          </div>
        </div>
   
 
      <FilterModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        formData={formData}
        setFormData={setFormData}
        filters={filters}
        setFilters={setFilters}
      />
    </div>
  );
}
